<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton :color="filters ? 'dark' : 'warning'" size="sm" @click="toggleFilters" style="height: 26px; padding: 2px 5px;"><CIcon name="cil-filter"/></CButton>
          <CButton color="success" size="sm" @click="importModal()" v-if="type == 'general' && permissions['sales.write'] === true">Importar Ventas</CButton>
          <CButton color="dark" size="sm" @click="openHistoricModal()" v-if="type == 'general' && permissions['sales.write'] === true">Historico Importador</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="filters">
        <CCol md="3">
          <div role="group" class="form-group" style="margin: -10px 0px 10px" v-if="type == 'general'">
            <label> Vendedor:</label>
            <CSelect
              :value.sync="supplierSelect" 
              :options="suppliersOptions"
              @change="changeFilters"
            />                        
          </div>
        </CCol>        
        <CCol md="3">
          <div role="group" class="form-group" style="margin: -10px 0px 10px" v-if="type == 'general'">
            <label> CEDIS:</label>
            <CSelect
              :value.sync="cedisSelect" 
              :options="cedisOptions"
              @change="changeFilters"
            />                        
          </div>
        </CCol>
        <CCol md="3">
          <div role="group" class="form-group" style="margin: -10px 0px 10px">
            <label> Rango de Fechas:</label>
            <v-date-picker                    
              v-model="range"    
              class="date-picker"
              locale="es-MX" size="sm"          
              mode="range"
              :popover="{ visibility: 'click' }"
            />        
          </div>
        </CCol>
      </CRow>
      <CDataTable
        :tableFilter="tableFilter"
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="perPage"
        :dark="dark"
      >
        <template #date="{item}"><td class="text-center w100 p-0" style="font-size: 11px;">{{item.date | date}}</td></template>
        <template #cedis_name="{item}"><td class="text-center w100 p-0" style="font-size: 11px;">{{item.cedis_name}}</td></template>
        <template #sname="{item}"><td class="text-left w300 p-0" style="font-size: 11px; padding-left: 5px !important;">{{item.supplier_code}} - {{item.supplier_name}}</td></template>
        <template #cname="{item}"><td class="text-left w300 p-0" style="font-size: 11px; padding-left: 5px !important;">{{item.customer_code}} - {{item.customer_name}}<br />{{item.product_name}}</td></template>
        <template #boxes="{item}"><td class="text-right w50 p-0" style="font-size: 11px; padding-right: 5px !important;">{{item.boxes}}</td></template>
        <template #total="{item}"><td class="text-right w50 p-0" style="font-size: 11px; padding-left: 5px !important; padding-right: 5px !important;"><span style="float: left;">$</span> {{item.total | currency}}</td></template>
        <template #actions="{item}">
          <td class="table_actions p-0" style="font-size: 11px;">
            <CButton color="danger" size="sm" @click="deleteModal(item)" v-if="permissions['sales.write'] === true"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
      <div class="d-flex justify-content-between align-items-center mt-2">
        <small>
          Mostrando {{ paginationInfo.from || 0 }} - {{ paginationInfo.to || 0 }} de {{ paginationInfo.total || 0 }}
        </small>
        <div>
          <CButton
            size="sm"
            color="secondary"
            class="mr-1"
            :disabled="(paginationInfo.current_page || 1) <= 1"
            @click="changeFilters((paginationInfo.current_page || 1) - 1)"
          >Anterior</CButton>
          <template v-for="(page, index) in numericPages">
            <CButton
              v-if="typeof page === 'number'"
              :key="`page-${page}-${index}`"
              size="sm"
              :color="page === (paginationInfo.current_page || 1) ? 'primary' : 'light'"
              class="mr-1"
              @click="changeFilters(page)"
            >{{ page }}</CButton>
            <span v-else :key="`ellipsis-${index}`" class="mx-1">...</span>
          </template>
          <CButton
            size="sm"
            color="secondary"
            :disabled="(paginationInfo.current_page || 1) >= (paginationInfo.last_page || 1)"
            @click="changeFilters((paginationInfo.current_page || 1) + 1)"
          >Siguiente</CButton>
        </div>
      </div>
    </CCardBody>
    <ImportSalesModal ref="importModal" @import="importProcess"></ImportSalesModal>
    <ImportHistoricModal ref="importHistoricModal" @reload="importProcess"></ImportHistoricModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import { DatePicker } from 'v-calendar'
import moment from 'moment';
import moment_timezone from 'moment-timezone';

import ImportSalesModal from './ImportSalesModal.vue'
import ImportHistoricModal from './ImportHistoricModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import suppliers_ws from '../../services/suppliers';
import cedis_ws from '../../services/cedis';
import ws from '../../services/sales';
import store from '../../store'
import { _ } from 'core-js';

export default {
  name: 'SalesTable',
  components: { ImportSalesModal, ImportHistoricModal, DeleteModal, 'v-date-picker': DatePicker },
  props: {
    items: Array,
    pagination: {
      type: Object,
      default: () => ({})
    },
    permissions: [Object, Array],
    fields: {
      default () {
        return [
          {key: 'date', label: 'Fecha', _style: 'font-size: 12px;'},
          {key: 'cedis_name', label: 'CEDIS', _style: 'font-size: 12px;'},
          {key: 'sname', label: 'Vendedor', _style: 'font-size: 12px;'},
          {key: 'cname', label: 'Cliente', _style: 'font-size: 12px;'},
          {key: 'boxes', label: 'Cajas', _style: 'font-size: 12px;'},
          {key: 'total', label: 'Monto', _style: 'font-size: 12px;'},
          {key: 'actions', label: 'Acciones', class: 'actions', _style: 'font-size: 12px;' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    type: {
      type: String,
      default: 'general'
    },
    reference: 0,
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      filters: false,
      customers: [],
      customerSelect: "",
      customersOptions: [],
      suppliers: [],
      supplierSelect: "",
      suppliersOptions: [],
      cedis: [],
      cedisSelect: "",
      cedisOptions: [],
      range: {
        start: new moment().startOf('month').toDate(),
        end: new moment().endOf("month").toDate(),
      },
      toasts: [],
      perPage: 100,
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  computed: {
    paginationInfo () {
      if (this.pagination && Object.keys(this.pagination).length > 0) {
        return this.pagination;
      }

      const total = Array.isArray(this.items) ? this.items.length : 0;
      return {
        total,
        per_page: this.perPage,
        current_page: 1,
        last_page: 1,
        from: total > 0 ? 1 : 0,
        to: total
      };
    },
    numericPages () {
      const lastPage = this.paginationInfo.last_page || 1;
      const currentPage = this.paginationInfo.current_page || 1;

      if (lastPage <= 9) {
        return Array.from({ length: lastPage }, (_, i) => i + 1);
      }

      const pages = [1];
      const start = Math.max(2, currentPage - 2);
      const end = Math.min(lastPage - 1, currentPage + 2);

      if (start > 2) {
        pages.push('left-ellipsis');
      }

      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }

      if (end < lastPage - 1) {
        pages.push('right-ellipsis');
      }

      pages.push(lastPage);

      return pages;
    }
  },
  mounted: async function() {
    this.loading();

    let response2 = await suppliers_ws.get(); 

    if(response2.type == "success"){
      this.suppliers = response2.data;
      this.suppliersOptions = await this.$parseSelectOptionsOrdered(this.suppliers, "id", "name",[{"label": "Todos los Vendedores","value":""}]);
    }

    let response3 = await cedis_ws.get(); 

    if(response3.type == "success"){
      this.cedis = response3.data;
      this.cedisOptions = await this.$parseSelectOptionsOrdered(this.cedis, "id", "name",[{"label": "Todos los CEDIS","value":""}]);
    }

    this.loaded();
  },
  methods: {
    normalizeItems(payload) {
      if (Array.isArray(payload)) {
        return payload;
      }

      if (payload && Array.isArray(payload.data)) {
        return payload.data;
      }

      return [];
    },
    toggleFilters () {
      this.filters = !this.filters;
    },
    async changeFilters (page = 1) {
      this.loading();

      let filters = this.getFilters(page);
      let response = await ws.getFiltered(filters);

      if(response.type == "success"){
        this.$emit("refresh", response);
      }

      this.loaded();
    },
    getFilters(page = 1){
      let filters = {
        date : [moment(this.range.start).format("YYYY-MM-DD"),moment(this.range.end).format("YYYY-MM-DD")],
        customer_id : this.customerSelect,
        supplier_id : this.supplierSelect,
        cedis_id : this.cedisSelect,
        page: page,
        per_page: this.perPage
      };

      if(this.type == "supplier"){
        filters.supplier_id = this.reference;
        filters.customer_id = 0;
        filters.cedis_id = 0;
      }

      if(this.type == "customer"){
        filters.customer_id = this.reference;
        filters.supplier_id = 0;
        filters.cedis_id = 0;
      }

      if(this.type == "cedis"){
        filters.cedis_id = this.reference;
        filters.supplier_id = 0;
        filters.customer_id = 0;
      }

      return filters;
    },
    openHistoricModal () {
      this.$refs.importHistoricModal.openModal();
    },
    importModal () {
      this.$refs.importModal.importModal();
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Venta", item.id, item.name);
    },
    async importProcess(data) {
      let filters = this.getFilters(this.paginationInfo.current_page || 1);
      let response = await ws.getFiltered(filters);

      if(response.type == "success"){
        this.$emit("refresh", response);
      }
    },
    
    async deleteProcess(id) {
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        await this.changeFilters(this.paginationInfo.current_page || 1);
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
  watch: {
    range: async function(){
      await this.changeFilters();
    }
  },
}
</script>
